<button
  mat-button
  class="secondary-btn"
  color="primary"
  [ngClass]="size"
  [disabled]="disabled"
  [ngStyle]="{'background': backgroundColor}"
  (click)="onClick($event)">
  <span>
    {{text}}
  </span>

  <img  *ngIf="icon" class="icon" alt="" [src]="iconUrl">
</button>
